const InvitationConstants = {
  InvitationState: {
    INVITATION: 1,
    REJECT: 2,
    UNVERIFIED_EMAIL: 3,
    MEMBERSHIP_EXISTS: 4,
    WELCOME_MESSAGE: 5,
    ERROR_MESSAGE: 6,
  },

  ResendStatus: {
    IDLE: 1,
    SENDING: 2,
    SENT: 3,
    ERROR: 4,
  },
};

export default InvitationConstants;

export const { InvitationState, ResendStatus } = InvitationConstants;
